module.exports = __webpack_public_path__ + "img/img0.62b13e74.jpg";